import { boot } from 'quasar/wrappers'
import truncateLink from '../functions/truncate-link'

export default boot(({ app }) => {
	app.config.globalProperties.$truncateLink = truncateLink
})
